import React from 'react'

type IconProps = {
    className?: string
}

export const LogoShortIcon: React.FC<IconProps> = ({ className }) => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <path d="M4 6.65307L6.5397 4H20L17.2064 6.65307H4Z" fill="#76BD1D" />
        <path d="M20 4V17.2392L17.2063 19.8744V6.65307L20 4Z" fill="#141A1F" />
        <path
            d="M4.50793 11.7982L7.04764 9.14514H14.7936L12 11.7982H4.50793Z"
            fill="#76BD1D"
        />
        <path
            d="M14.7936 9.14514V17.3647L12 20V11.7982L14.7936 9.14514Z"
            fill="#141A1F"
        />
    </svg>
)
